__turbopack_context__.v({
  "buttonsWrapper": "UnpairVPadModal-module__FqVfTq__buttonsWrapper",
  "content": "UnpairVPadModal-module__FqVfTq__content",
  "unpairVPadModal": "UnpairVPadModal-module__FqVfTq__unpairVPadModal",
});
